import { useEffect } from 'react'

/**
 * It will call handler when event happens on globalThis.window?.
 * @param handler
 */
export function useCallOnEvent(handler: () => void, event: string) {
  useEffect(() => {
    // Recommended method for validating window prior to SSR per Gatsby documentation: https://www.gatsbyjs.com/docs/debugging-html-builds/
    const isBrowser = !!globalThis.window
    isBrowser && globalThis.window.addEventListener(event, handler)
    return () => {
      isBrowser && globalThis.window.removeEventListener(event, handler)
    }
  }, [handler])
}
